var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthiconsUiUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0 1c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    fill: "#192048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.815c0-.517.386-.953.9-1.01 3.857-.427 6.36-.389 10.209.01a.995.995 0 0 1 .554 1.735c-4.543 3.96-7.139 3.905-11.343.005a1.01 1.01 0 0 1-.32-.74z",
    fill: "#192048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.058 17.311c-3.819-.395-6.285-.431-10.104-.009a.514.514 0 0 0-.294.886c2.084 1.933 3.663 2.806 5.207 2.812 1.548.006 3.212-.861 5.467-2.826a.496.496 0 0 0-.276-.862zM6.845 16.308c3.898-.431 6.437-.393 10.316.009a1.495 1.495 0 0 1 .831 2.61c-2.288 1.995-4.193 3.08-6.129 3.073-1.941-.007-3.762-1.111-5.882-3.079a1.509 1.509 0 0 1-.481-1.106 1.514 1.514 0 0 1 1.345-1.508v.001z",
    fill: "#192048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
    fill: "#192048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthiconsUiUserProfile);
export default __webpack_public_path__ + "static/media/healthicons_ui-user-profile.46f3baa1ab3624576b5dc25f1ae20ae4.svg";
export { ForwardRef as ReactComponent };